import React from 'react'
import PropTypes from 'prop-types'
import ExpandMore from '@mui/icons-material/ExpandMore'
import Select from 'components/generic/form/Select'

const SelectChip = ({ control, items, selectProps, ...restProps }) => (
  <Select
    name="status"
    defaultValue=""
    control={control}
    selectProps={{
      IconComponent: ExpandMore,
      displayEmpty: true,
      label: undefined,
      sx: {
        '& .MuiSelect-select': {
          fontSize: '0.8125rem',
        },
        borderRadius: '16px',
        height: '32px',
      },
      ...selectProps,
    }}
    items={items}
    sx={{ padding: 0 }}
    {...restProps}
  />
)

SelectChip.propTypes = {
  control: PropTypes.object.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  selectProps: PropTypes.object,
}

SelectChip.defaultProps = {
  selectProps: {},
}

export default SelectChip
